import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

export interface IControlTestScriptState {
	resetTestStepsState: boolean;
	controlStepsList: string[];
	controlTestClicked: boolean;
	testMonitoringSelectedTab: number;
}

const initialState: IControlTestScriptState = {
	resetTestStepsState: false,
	controlStepsList: [],
	controlTestClicked: false,
	testMonitoringSelectedTab: 0,
};

export const controlTestScriptSlice = createSlice({
	name: 'controlTestScript',
	initialState,
	reducers: {
		setControlStepsInfo: (state, action: PayloadAction<boolean>) => {
			state.resetTestStepsState = action.payload;
		},
		setControlStepsData: (state, action: PayloadAction<string[]>) => {
			state.controlStepsList = action.payload;
		},
		setControlTestClicked: (state, action: PayloadAction<boolean>) => {
			state.controlTestClicked = action.payload;
		},
		setTMSelectedTab: (state, action: PayloadAction<number>) => {
			state.testMonitoringSelectedTab = action.payload;
		},
	},
});

export const {
	setControlStepsInfo,
	setControlStepsData,
	setControlTestClicked,
	setTMSelectedTab,
} = controlTestScriptSlice.actions;
export default controlTestScriptSlice.reducer;
